import { createContext, useContext } from 'react';

export type PublicationMode = 'app' | 'public';

export const PublicationModeContext = createContext<PublicationMode>('public');

export function usePublicationMode() {
  return useContext(PublicationModeContext);
}
